<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <p class="text-body-2">{{ $t('docs.pageText') }}</p>

        <v-list three-line>
          <v-list-item v-for="doc in list" :key="doc.docid" @click="openDocument(doc)">
            <v-list-item-icon>
              <v-icon color="primary">mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <h4>{{ doc.docname[lang] }}</h4>
              </v-list-item-title>
              <v-list-item-subtitle>
                <p>{{ doc.date }}</p>
                <p style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-bottom: 0"> {{ doc.description[lang]}}</p>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import downloadFile from "@/utils/downloadFile";

export default {
  name: "Documents",

  data() {
    return {
      loading: true,
      list: [],
    };
  },
  computed: {
    lang() {
      return ((s) => s.replace(s[0], s[0].toUpperCase()))(this.$i18n.locale);
    }
  },
  methods: {
    loadDocs() {
      this.loading = true;
      this.$store.dispatch('app/loadDocuments')
        .then((data) => {
          this.list = data;
          this.loading = false;
        })
    },

    openDocument(doc) {
      const uri = doc.docuri[this.lang];
      this.$store.dispatch('app/downloadDocument', {uri, type: doc.doctype})
        .then((uri) => {
          downloadFile(doc.docname[this.lang], uri);
        });

    }
  },
  mounted() {
    this.loadDocs();
  }
}
</script>

<style>

</style>